@if (step == 1) {
  <app-new-decision-table-select-framework [project_id]="project_id" [frameworkState]="frameworkSelectionState" (frameworkSelectedEvent)="frameworkSelected($event)" (goBackEvent)="goToHome()"></app-new-decision-table-select-framework>
}
@if (step == 2) {
  <app-new-decision-table-compile-problem-statement [project_id]="project_id" [problemStatementModel]="problemStatementState" (problemStatementCompletedEvent)="problemStatementCompleted($event)" (goBackEvent)="goToFrameworkSelection()"></app-new-decision-table-compile-problem-statement>
}
@if (step == 3) {
  <app-new-decision-table-compile-proposal [project_id]="project_id" [frameworkModel]="frameworkSelectionState.model" [problemStatementModel]="problemStatementState" (goBackEvent)="goToProblemStatementSelection()"></app-new-decision-table-compile-proposal>
}
